import { FunctionComponent, ReactNode } from 'react'
import useIsInUltraModuleBundling from '@hooks/useIsInUltraModuleBundling'
import styled, { css } from 'styled-components'
import { desktopCSS, tabletCSS } from '@measures/responsive'
import useShowBundling from '@hooks/useShowBundling'

interface RelatedItemsWrapperProps {
  children?: ReactNode
  accentColor?: string
}

const StyledRelatedItemsWrapper = styled.div<
  Pick<RelatedItemsWrapperProps, 'accentColor'>
>`
  ${({
    theme: {
      colors: { staticRed500 },
      spacing: { spacing8, spacing16, spacing24, spacing32 },
      measures: { stretchWidthOnMobile },
    },
    accentColor,
  }) => css`
    ${desktopCSS(css`
      display: none;
    `)}
    display: grid;
    grid-row-gap: ${spacing16};
    position: relative;
    ${stretchWidthOnMobile};

    &:after {
      content: '';
      position: absolute;

      bottom: -${spacing32};
      left: 0;
      width: calc(100% + ${spacing16} + ${spacing8});
      ${tabletCSS(css`
        width: calc(100% + ${spacing16} + ${spacing8});
        margin-left: -${spacing16};
        margin-right: -${spacing8};
      `)}
      height: 24px;

      z-index: 1;
      background-color: ${accentColor ?? staticRed500};
      clip-path: polygon(0 0, 100% 0, 0 100%);

      ${stretchWidthOnMobile};
    }

    margin-bottom: ${spacing24};
    margin-top: -${spacing24};
    padding-top: ${spacing16};

    border-style: solid;
    border-color: ${accentColor ?? staticRed500};
    border-width: 0 ${spacing8} ${spacing8} ${spacing16};

    a {
      &:before {
        content: '';
        position: absolute;

        top: -${spacing16};
        left: 0;
        width: 124px;
        height: 16px;

        z-index: 1;
        background-color: ${accentColor ?? staticRed500};
      }
    }
  `}
`

const RelatedItemsWrapper: FunctionComponent<RelatedItemsWrapperProps> = ({
  children,
  accentColor,
}) => {
  const hasBundling = useIsInUltraModuleBundling()
  const shouldShowBundling = useShowBundling() && hasBundling
  if (!children) {
    return null
  }
  if (!shouldShowBundling) {
    return children
  }

  return (
    <StyledRelatedItemsWrapper accentColor={accentColor}>
      {children}
    </StyledRelatedItemsWrapper>
  )
}

export default RelatedItemsWrapper
